import React, { Component } from 'react';
import moment from 'moment';
import toast from '@util/toast';
import tool from '@util/tool';
export function WithAriticleEdit(store?: any) {
    return ArticleEditComponent => {
        class EditArticleHOC extends Component<any, any> {
            public cropper: any;
            public cropperInput: any;
            public editor: any;
            public client: any;
            public aliyunHost: any;
            public videoUploader: any;
            public timeDay: any;
            public timeHour: any;
            public timeMinute: any;
            public itemEditorCon: any;
            public config: any = {
                headers: {
                    // 'X-CHJ-Token': window.sessionStorage.getItem('ACCESSTOKEN') || 'app_sign_13cf8fc55ac9407694ed46de06d49ceb',
                    // 'X-CHJ-Deviceid': 'f06af636000000000'
                }
            };
            constructor(props) {
                super(props);
                this.state = {
                    src: '', // 测试图片 http://c.hiphotos.baidu.com/image/h%3D300/sign=c635d3753efa828bce239be3cd1f41cd/0eb30f2442a7d933b29eb303a04bd11373f0018f.jpg
                    cropHasHide: true,
                    cropImg: '',
                    editorContent: '',
                    previewContent: '',
                    textareaHide: true,
                    timingPublicBoxHasHide: true,
                    previewBoxHasHide: true,
                    textareaArticleBoxZIndex: false,
                    articleTitle: '',
                    publicTime: '',
                    editorContentLength: 0,
                    saveStatus: '未保存',
                    HasTipShow: false,
                    userName: '',
                    avatar: '',
                    hasFixdEditor: false,
                    timeDay: ['今天', '明天'],
                    timeHour: [],
                    timeMinute: [],
                    commentLimit: false,
                    productId: null,
                    articleQrcode: '',
                    groupId:'',
                    releaseTime:'',
                    releaseType:''
                };
            }
            public dataURLtoFile(dataurl, filename) {
                // 将base64转换为文件
                const arr = dataurl.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, { type: mime });
            }
            // 获取手机预览二维码
            public getPhoneQrcode = (productId?) => {
                const id = productId || this.state.productId;
                this.props.store.getArticlePreviewQrcode
                    .get(id)
                    .then(res => {
                        console.log('获取手机预览二维码成功', res);
                        this.setState({
                            articleQrcode: res
                        });
                    })
                    .catch(err => {
                        console.log('获取手机预览二维码失败', err);
                        toast.error(err.msg || '网络状况不太好');
                    });
            };
            // 获取文章详情
            public getArticleDetail = id => {
                const type = this.getQueryString('type');
                const info = {
                    type
                };
                this.config.params = info;
                this.props.store.articleDetail
                    .init(id, this.config)
                    .then(res => {
                        console.log('获取详情成功', res);
                        this.getSwichUploadDom('editor', res.content, html => {
                            let text = html.replace(/<.*?>/g, () => {
                                return '';
                            });
                            text = text.replace(/\u200b/gm, '');
                            this.setState({
                                editorContent: html,
                                editorContentLength: text.length
                            });
                        });

                        this.setState({
                            cropImg: res.surfacePlot,
                            releaseType: 1,
                            articleTitle: res.title,
                            commentLimit: res.commentLimit,
                            productId: res.productId,
                            status: res.status
                        });
                    })
                    .catch(err => {
                        console.log('获取详情失败', err);
                    });
            };
            // 创建文章
            public createArticle = (param, cb) => {
                console.log('param', param);
                param.content = tool.removeQueryFromContent(param.content)
                this.props.store.articleCreateUpdate
                    .init(param, this.config)
                    .then(res => {
                        cb && cb();
                        sessionStorage.removeItem('DRAFTID');
                        console.log('发布文章成功', res);
                        window.location.href = '/';
                    })
                    .catch(err => {
                        console.log('发布文章失败', err);
                        toast.error(err.msg || '网络状况不太好');
                    });
            };
            // 保存草稿
            public saveDraft = (param, hasLink?: boolean) => {
                this.props.store.articleSaveDraft
                    .init(param, this.config)
                    .then(res => {
                        console.log('保存草稿成功', res);
                        sessionStorage.setItem('DRAFTID', res.id);
                        this.setState({
                            saveStatus: '已保存',
                            productId: res.productId
                        });
                        if (hasLink) {
                            window.location.href = '/';
                        }
                    })
                    .catch(err => {
                        console.log('保存草稿失败', err);
                        if (hasLink) {
                            toast.error(err.msg);
                        }
                        if (err.code === 240906) {
                            toast.error(err.msg);
                        }
                        this.setState({
                            saveStatus: '保存失败，请及时手动保存'
                        });
                    });
            };
            public onChange = e => {
                e.preventDefault();
                let files;
                if (e.dataTransfer) {
                    files = e.dataTransfer.files;
                } else if (e.target) {
                    files = e.target.files;
                }
                if (/\.(jpg|jpeg|png)$/i.test(files[0].name) === false) {
                    toast.error('图片验证未通过:不支持该格式');
                    return;
                } else if (files[0].size / 1024 / 1024 > 5) {
                    toast.error('上传图片不能超过5M');
                    return;
                } else {
                    this.setState({
                        cropHasHide: false,
                        textareaArticleBoxZIndex: true
                    });
                    const reader = new FileReader();
                    reader.onload = () => {
                        this.setState({ src: reader.result });
                        // console.log(reader.result);
                    };

                    reader.readAsDataURL(files[0]);
                }
            };
            public closeCrop = e => {
                e.preventDefault();
                this.setState({ src: '' });
                this.setState({
                    cropHasHide: true,
                    timingPublicBoxHasHide: true,
                    previewBoxHasHide: true,
                    textareaArticleBoxZIndex: false
                });
            };
            //   裁剪图片
            public cropImage = e => {
                this.closeCrop(e);
                if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
                    return;
                }

                // 上传封面图
                this.props.getStsWrite(
                    this.dataURLtoFile(
                        this.cropper.getCroppedCanvas().toDataURL('image/png'),
                        '123.png'
                    ),
                    data => {
                        if (data.name || data.url) {
                            this.setState(
                                {
                                    cropImg: data.url
                                },
                                () => {
                                    this.checkSaveDraft();
                                }
                            );
                        } else {
                            toast.error('图片上传失败');
                        }
                    }
                );
            };
            public getCropImg(src) {
                this.setState({
                    src
                });
            }
            public getTitle = e => {
                this.setState(
                    {
                        articleTitle: e.target.value
                    },
                    () => {
                        // this.checkSaveDraft();
                    }
                );
            };
            public getChildRefs = ref => {
                this[ref.name] = ref.value;
            };
            public setStates = stateObj => {
                this.setState({
                    ...stateObj
                });
            };
            public getSwichUploadDom = (type: string, dom, fn) => {
                // type:load:上传前转换；editor:渲染编辑器转换
                if (document.querySelectorAll('.itemEditorCon')) {
                    document.querySelectorAll(
                        '.itemEditorCon'
                    )[0].innerHTML = dom;
                    if (
                        document.querySelectorAll('.itemEditorCon .unitImgBox')
                            .length > 0
                    ) {
                        const $uniImgBox = document.querySelectorAll(
                            '.itemEditorCon .unitImgBox'
                        );
                        if (type === 'load') {
                            const $currentImgDesc = document.querySelectorAll(
                                '.itemEditorCon .editor-img-caption-wrapper input'
                            );
                            for (let i = 0; i <= $uniImgBox.length - 1; i++) {
                                const $currentImg = document.querySelectorAll(
                                    '.itemEditorCon .unitImgBox img'
                                )[i];
                                const imgString = this.nodeToString(
                                    $currentImg
                                );
                                // $uniImgBox[i].innerHTML = '<p  style="width:100%;text-align:center;">' + imgString + '</p><center class="editorImgDesc">' + $currentImgDesc[i]['value'] + '</center>';
                                $uniImgBox[i].innerHTML =
                                    imgString +
                                    '<center class="editorImgDesc">' +
                                    $currentImgDesc[i]['value'] +
                                    '</center>';
                            }
                        } else if (type === 'editor') {
                            const $currentImgDesc =
                                (document.querySelectorAll(
                                    '.itemEditorCon .unitImgBox i'
                                ).length > 0 &&
                                    document.querySelectorAll(
                                        '.itemEditorCon .unitImgBox i'
                                    )) ||
                                document.querySelectorAll(
                                    '.itemEditorCon .unitImgBox center'
                                );
                            for (let j = 0; j <= $uniImgBox.length - 1; j++) {
                                const $currentImg = document.querySelectorAll(
                                    '.itemEditorCon .unitImgBox img'
                                )[j];
                                const imgString = this.nodeToString(
                                    $currentImg
                                );
                                let descCon = '';
                                if ($currentImgDesc && $currentImgDesc[j]) {
                                    descCon = $currentImgDesc[j].innerHTML;
                                }
                                $uniImgBox[j].innerHTML =
                                    '<div class="editor-img-wrapper">' +
                                    imgString +
                                    '<span class="editor-img-wrapper-close"></span>' +
                                    '</div>' +
                                    '<div class="editor-img-caption-wrapper">' +
                                    '<input class="editor-img-caption-ipt"  maxLength="32" placeholder="图片描述(最多32字)" value="' +
                                    descCon +
                                    '">' +
                                    '</div>';
                            }
                        }
                    }
                    const $itemEditorCon =
                        this.itemEditorCon &&
                        (this.itemEditorCon as HTMLDivElement);
                    if (
                        $itemEditorCon &&
                        $itemEditorCon.getElementsByClassName('editorVideoBox')
                            .length > 0
                    ) {
                        const $editorVideoBox = $itemEditorCon.getElementsByClassName(
                            'editorVideoBox'
                        );
                        if (type === 'load') {
                            for (
                                let i = 0;
                                i <= $editorVideoBox.length - 1;
                                i++
                            ) {
                                const $currentImg = $itemEditorCon.getElementsByClassName(
                                    'videoBox'
                                )[i];
                                const videoId =
                                    $currentImg &&
                                    $currentImg.getAttribute('data-videoId');
                                const poster =
                                    $currentImg &&
                                    $currentImg.getAttribute('src');
                                const playUrl =
                                    $currentImg &&
                                    $currentImg.getAttribute('data-playUrl');
                                const pixel =
                                    $currentImg &&
                                    $currentImg.getAttribute('data-pixel');
                                // $editorVideoBox[i].innerHTML = '<p  style="width:100%;text-align:center;"><video class="videoBox ' + videoId + '" poster="' + poster + '" data-videoId="' + videoId + '" src="' + playUrl + '" style="max-width: 80%;max-height:80%;text-align:center;" controls autobuffer ></video><br></p>';
                                $editorVideoBox[i].innerHTML =
                                    '<video class="videoBox ' +
                                    videoId +
                                    '" poster="' +
                                    poster +
                                    '" data-videoId="' +
                                    videoId +
                                    '" data-pixel="' +
                                    pixel +
                                    '" src="' +
                                    playUrl +
                                    '" style="max-width: 80%;max-height:80%;text-align:center;" controls autobuffer ></video>';
                            }
                        } else if (type === 'editor') {
                            for (
                                let i = 0;
                                i <= $editorVideoBox.length - 1;
                                i++
                            ) {
                                const $currentImg = $itemEditorCon.getElementsByClassName(
                                    'videoBox'
                                )[i];
                                const videoId =
                                    $currentImg &&
                                    $currentImg.getAttribute('data-videoId');
                                const pixel =
                                    $currentImg &&
                                    $currentImg.getAttribute('data-pixel');
                                const poster =
                                    $currentImg &&
                                    $currentImg.getAttribute('poster');
                                const playUrl =
                                    $currentImg &&
                                    $currentImg.getAttribute('src');
                                $editorVideoBox[i].innerHTML =
                                    '<div class="editorVideo">' +
                                    '<div class="videoImgCon">' +
                                    '<span class="videoClose"></span>' +
                                    '<img class="videoBox" src="' +
                                    poster +
                                    '" data-videoId="' +
                                    videoId +
                                    '" alt="文字视频" data-playUrl="' +
                                    playUrl +
                                    '" data-pixel="' +
                                    pixel +
                                    '"/>' +
                                    '<div class="cover" contenteditable="false">更换封面图</div>' +
                                    '<div class="tip" contenteditable="false">视频尚未发布，暂时无法播放</div>' +
                                    '<span class="videoPlay"></span>' +
                                    '</div>' +
                                    '</div><br>';
                            }
                        }
                    }

                    fn(
                        this.itemEditorCon &&
                            (this.itemEditorCon as HTMLDivElement).innerHTML
                    );
                }
            };
            public nodeToString = node => {
                if (node) {
                    let tmpNode = document.createElement('div');
                    tmpNode.appendChild(node.cloneNode(true));
                    const str = tmpNode.innerHTML;
                    tmpNode = node = null; // prevent memory leaks in IE
                    return str;
                }
                return null;
            };
            public showPreview = () => {
                const { editorContent } = this.state;
                let { articleTitle } = this.state;
                articleTitle = articleTitle.replace(/\s+/g, '');
                if (!articleTitle) {
                    toast.error('标题不能为空');
                    return;
                }
                if (!editorContent) {
                    toast.error('文章内容不可为空');
                    return;
                }
                if (!this.state.cropImg) {
                    toast.error('请上传文章封面图片');
                    return;
                }
                this.checkSaveDraft();
                this.getSwichUploadDom(
                    'load',
                    this.state.editorContent,
                    html => {
                        console.log(html);
                        html = html.replace(/<p><\/p>/gim, '');
                        this.setState({
                            previewContent: html,
                            previewBoxHasHide: false,
                            textareaArticleBoxZIndex: true
                        });
                    }
                );
                this.getPhoneQrcode(this.state.productId);
            };
            public showTimeing = () => {
                this.timeOnchange();
                this.setState({
                    timingPublicBoxHasHide: false,
                    textareaArticleBoxZIndex: true
                });
            };
            public timeOnchange = () => {
                // console.log(e.target.id);
                const timeDay =
                    this.timeDay.selectedIndex === 0 ? 'today' : 'tomorrow';
                const timeHour = Number(this.timeHour.value);
                this.setTime(timeDay, timeHour);
            };
            public setTime = (time?: string, hour?: number) => {
                time = time || 'today';
                const currentHour = hour || Number(moment().format('HH'));
                const timestamp = new Date().getTime();
                const twoHourTimestamp = 2 * 60 * 60 * 1000;
                const Hour24Timestamp = 24 * 60 * 60 * 1000;
                const minHour =
                    time === 'today'
                        ? Number(
                              moment(timestamp + twoHourTimestamp).format('HH')
                          )
                        : 0;
                const maxHour =
                    time === 'today'
                        ? 23
                        : Number(
                              moment(timestamp + Hour24Timestamp).format('HH')
                          );
                const maxMinute =
                    time === 'tomorrow' && currentHour === maxHour
                        ? Number(
                              moment(timestamp + Hour24Timestamp).format('mm')
                          )
                        : 59;
                const minMinute =
                    (time === 'today' && currentHour > minHour) ||
                    time === 'tomorrow'
                        ? 0
                        : Number(
                              moment(timestamp + twoHourTimestamp).format('mm')
                          );
                // console.log(currentHour,minHour,minMinute,maxMinute,moment(timestamp+twoHourTimestamp).format('YYYY-MM-DD HH:mm:ss'));
                const hourArr = [];
                const minuteArr = [];
                for (let i = minMinute; i <= maxMinute; i++) {
                    if (i < 10) {
                        minuteArr.push('0' + i);
                    } else {
                        minuteArr.push(i + '');
                    }
                }

                for (let i = minHour; i <= maxHour; i++) {
                    hourArr.push(i);
                }

                this.setState({
                    timeHour: hourArr,
                    timeMinute: minuteArr
                });
            };
            public getPublicTime = e => {
                // console.log(this.timeDay.value);
                this.closeCrop(e);
                let time = '';
                const timeHour =
                    this.timeHour.value.length > 1
                        ? this.timeHour.value
                        : '0' + this.timeHour.value;
                if (this.timeDay.value === '今天') {
                    time = moment().format('YYYY-MM-DD');
                } else {
                    time =
                        moment().format('YYYY-MM') +
                        '-' +
                        (Number(moment().format('DD')) + 1);
                }

                time =
                    time +
                    ' ' +
                    timeHour +
                    ':' +
                    this.timeMinute.value +
                    ':' +
                    '00';

                // console.log(time);
                this.setState({
                    publicTime: time
                });
            };
            public getQueryString(name) {
                const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
                const r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return decodeURI(r[2]);
                }
                return null;
            }
            // public removeQueryFromHtml = (html) => {
            //   const regex = /(https?:\/\/[\w./?=#&%-]+)\b/g;
            //   return html.replace(regex, (match, url) => {
            //     const parsedUrl = new URL(url);
            //     return parsedUrl.origin + parsedUrl.pathname;
            //   });
            // }
            public checkSaveDraft = (hasLink?: boolean) => {
                const {
                    cropImg,
                    articleTitle,
                    editorContent,
                    commentLimit,
                    groupId,
                    releaseTime,
                } = this.state;
                const id =
                    this.getQueryString('id') ||
                    sessionStorage.getItem('DRAFTID') ||
                    this.props.match.params.id;
                if (
                    cropImg ||
                    articleTitle ||
                    (editorContent && editorContent !== '<p><br></p>')
                ) {
                    this.setState({
                        saveStatus: '保存中'
                    });
                    const article: any = {};
                    article.title = articleTitle;
                    article.surfacePlot = cropImg;
                    article.commentLimit = commentLimit;
                    article.groupId = groupId;
                    if(releaseTime){
                        article.releaseTime = releaseTime;
                    }
                    if (id) {
                        article.articleId = id;
                    }
                    this.getSwichUploadDom(
                        'load',
                        this.state.editorContent,
                        html => {
                            html = tool.removeQueryFromContent(html);
                            html = html.replace(/<p><\/p>/gim, '');
                            article.content = html;
                            this.saveDraft(article, hasLink);
                        }
                    );
                } else {
                    if (hasLink) {
                        toast.error('文章标题、封面、内容不可为空');
                    }
                }
            };
            public checkCreateArticel = cb => {
                const {
                    cropImg,
                    editorContent,
                    commentLimit,
                    groupId,
                    releaseTime
                } = this.state;
                let { articleTitle } = this.state;
                const article: any = {};
                articleTitle = articleTitle.replace(/(^\s*)|(\s*$)/g, '');
                article.title = articleTitle;
                article.surfacePlot = cropImg;
                article.commentLimit = commentLimit;
                article.groupId = groupId;
                if (releaseTime) {
                    if (moment(releaseTime).valueOf() < Date.now()) {
                        toast.error('仅支持选择此刻之后14天时间');
                        return;
                    }
                    article.releaseTime = releaseTime;
                }
                article.articleId =
                    this.props.match.params.id ||
                    this.getQueryString('id') ||
                    sessionStorage.getItem('DRAFTID');
                if (!articleTitle) {
                    toast.error('标题不能为空');
                    return;
                }
                if (!cropImg) {
                    toast.error('请传入文章封面图片！');
                    return;
                }
                if (!editorContent || editorContent === '<p><br></p>') {
                    toast.error('文章内容不可为空');
                    return;
                }
                this.getSwichUploadDom(
                    'load',
                    this.state.editorContent,
                    html => {
                        html = html.replace(/<p><\/p>/gim, '');
                        article.content = html;
                        this.createArticle(article, cb);
                    }
                );
            };
            public resetCon = () => {
                sessionStorage.removeItem('DRAFTID');
                this.setState({
                    cropImg: '',
                    articleTitle: '',
                    editorContent: '<p><br></p>',
                    HasTipShow: false
                });
            };
            public commentChange = value => {
                this.setState({
                    commentLimit: value
                });
            };
            public groupChange = value => {
                this.setState({
                    groupId: value
                });
            };
            public releaseTimeChange = value => {
                this.setState({
                    releaseTime: value
                });
            };
            public releaseTypeChange = value => {
                this.setState({
                    releaseType: value
                });
            };
            public componentWillMount() {
                this.props.store.hasLoginManage();
                const id = this.getQueryString('id');
                const groupId = this.getQueryString('groupId')||'';
                const draftId = sessionStorage.getItem('DRAFTID');
                if(groupId){
                    this.setState({
                        groupId: groupId
                    });
                }
                if (id) {
                    this.getArticleDetail(id);
                } else if (this.props.match.params.id) {
                    this.getArticleDetail(this.props.match.params.id);
                } else if (sessionStorage.getItem('DRAFTID')) {
                    this.getArticleDetail(draftId);
                    this.setState({
                        HasTipShow: true
                    });
                }
                // 获取用户信息
                if (sessionStorage.getItem('USERINFO')) {
                    const userInfo = JSON.parse(
                        sessionStorage.getItem('USERINFO')
                    );
                    // console.log(userInfo);
                    this.setState({
                        userName: userInfo.nickname,
                        avatar: userInfo.avatar
                    });
                }
            }
            public componentDidMount() {
                console.log(this.props);
                console.log('EditArticleHOC');
            }
            public render() {
                const newProps = {
                    getCropImg: this.getCropImg,
                    getChildRefs: this.getChildRefs,
                    onChange: this.onChange,
                    cropImage: this.cropImage,
                    getTitle: this.getTitle,
                    showPreview: this.showPreview,
                    setStates: this.setStates,
                    closeCrop: this.closeCrop,
                    showTimeing: this.showTimeing,
                    timeOnchange: this.timeOnchange,
                    checkSaveDraft: this.checkSaveDraft,
                    checkCreateArticel: this.checkCreateArticel,
                    getPublicTime: this.getPublicTime,
                    resetCon: this.resetCon,
                    commentChange: this.commentChange,
                    groupChange: this.groupChange,
                    releaseTimeChange: this.releaseTimeChange,
                    releaseTypeChange: this.releaseTypeChange,
                    ...this.props,
                    ...this.state
                };
                return <ArticleEditComponent {...newProps} />;
            }
        }

        return store ? store(EditArticleHOC) : EditArticleHOC;
    };
}
